import React, { useEffect, useState } from 'react';
import { FiSearch, FiX, FiEdit2, FiTrash2 } from 'react-icons/fi';
import API from '../utils/api';
import { toast } from 'react-toastify';
import { motion, AnimatePresence } from 'framer-motion';
import './AdminPages.css';

const STATUSES = ['','pending','confirmed','completed','cancelled'];

export default function AdminBookings() {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('');
  const [search, setSearch] = useState('');
  const [editModal, setEditModal] = useState(null);
  const [editStatus, setEditStatus] = useState('');

  const fetch = () => {
    setLoading(true);
    API.get('/api/admin/bookings', { params: { status: filter || undefined, limit: 100 } })
      .then(r => setBookings(r.data.data))
      .catch(() => toast.error('Failed to load bookings'))
      .finally(() => setLoading(false));
  };

  useEffect(fetch, [filter]);

  const handleStatusUpdate = async () => {
    try {
      await API.put(`/api/admin/bookings/${editModal._id}`, { status: editStatus });
      toast.success('Booking status updated');
      setEditModal(null);
      fetch();
    } catch { toast.error('Update failed'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this booking?')) return;
    try {
      await API.delete(`/api/admin/bookings/${id}`);
      toast.success('Booking deleted');
      fetch();
    } catch { toast.error('Delete failed'); }
  };

  const filtered = bookings.filter(b =>
    b.name?.toLowerCase().includes(search.toLowerCase()) ||
    b.email?.toLowerCase().includes(search.toLowerCase()) ||
    b.trip?.title?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      <div className="admin-page-header">
        <div><h2>Bookings</h2><p>{bookings.length} total bookings</p></div>
      </div>

      <div className="admin-card">
        <div className="admin-card-header">
          <div className="admin-filters" style={{ margin: 0 }}>
            <div className="admin-search">
              <FiSearch />
              <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search bookings..." />
              {search && <button style={{ position:'absolute',right:10,background:'none',border:'none',cursor:'pointer' }} onClick={() => setSearch('')}><FiX /></button>}
            </div>
            <select className="admin-filter-select" value={filter} onChange={e => setFilter(e.target.value)}>
              {STATUSES.map(s => <option key={s} value={s}>{s || 'All Status'}</option>)}
            </select>
          </div>
        </div>
        <div className="admin-table-wrap">
          {loading ? <div className="spinner" style={{ margin:'40px auto' }} /> : (
            <table className="admin-table">
              <thead><tr><th>Traveler</th><th>Trip</th><th>Travelers</th><th>Date</th><th>Amount</th><th>Status</th><th>Actions</th></tr></thead>
              <tbody>
                {filtered.length > 0 ? filtered.map(b => (
                  <tr key={b._id}>
                    <td>
                      <strong style={{ display:'block' }}>{b.name || b.user?.name || '—'}</strong>
                      <small style={{ color:'var(--text-light)' }}>{b.email || b.user?.email}</small>
                    </td>
                    <td style={{ maxWidth:180, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{b.trip?.title || '—'}</td>
                    <td>{b.travelers}</td>
                    <td>{b.travelDate ? new Date(b.travelDate).toLocaleDateString('en-IN', { day:'numeric', month:'short', year:'numeric' }) : '—'}</td>
                    <td>₹{b.totalAmount?.toLocaleString()}</td>
                    <td><span className={`badge-status ${b.status}`}>{b.status}</span></td>
                    <td>
                      <div className="action-btns">
                        <button className="btn-action edit" onClick={() => { setEditModal(b); setEditStatus(b.status); }} title="Change Status"><FiEdit2 /></button>
                        <button className="btn-action delete" onClick={() => handleDelete(b._id)} title="Delete"><FiTrash2 /></button>
                      </div>
                    </td>
                  </tr>
                )) : <tr><td colSpan={7}><div className="admin-empty">No bookings found</div></td></tr>}
              </tbody>
            </table>
          )}
        </div>
      </div>

      <AnimatePresence>
        {editModal && (
          <motion.div className="admin-modal-overlay" initial={{ opacity:0 }} animate={{ opacity:1 }} exit={{ opacity:0 }} onClick={e => e.target === e.currentTarget && setEditModal(null)}>
            <motion.div className="admin-modal" style={{ maxWidth:420 }} initial={{ scale:0.9 }} animate={{ scale:1 }} exit={{ scale:0.9 }}>
              <div className="admin-modal-header">
                <h3>Update Booking Status</h3>
                <button className="admin-modal-close" onClick={() => setEditModal(null)}><FiX /></button>
              </div>
              <div className="admin-modal-body">
                <p style={{ marginBottom:12, fontSize:'0.88rem', color:'var(--text-light)' }}>Booking by <strong>{editModal.name}</strong> for <strong>{editModal.trip?.title}</strong></p>
                <div className="form-group">
                  <label>Status</label>
                  <select value={editStatus} onChange={e => setEditStatus(e.target.value)}>
                    {STATUSES.slice(1).map(s => <option key={s}>{s}</option>)}
                  </select>
                </div>
              </div>
              <div className="admin-modal-footer">
                <button className="btn-admin-danger" onClick={() => setEditModal(null)}>Cancel</button>
                <button className="btn-admin-primary" onClick={handleStatusUpdate}>Update Status</button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
